import styled from 'styled-components';

const Container = styled.div`
  box-sizing: content-box;
  margin-left: auto;
  margin-right: auto;
  max-width: 1440px;
  width: 100%;
`;

export { Container };
